import React from "react"

// Styles
import * as styles from "./NavigationMobile.module.scss"

const NavigationMobile = (props) => (

    <div className={`${styles.NavigationMobile} ${props.isMobileMenuVisible ? styles.isActive : ''}`}>
        {props.children}
    </div>

)

export default NavigationMobile